import { ApiService, GenericError} from './api-main'
import { f7 } from 'framework7-vue';
import TokenService from './token-service'
import store            from '../store';
import CryptoAES        from 'aes-ecb'

class AuthenticationError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const CustomerService = {
    /**
     * Login the user and store the access token to TokenService.
     *
     * @returns access_token
     * @throws AuthenticationError
    **/
    login: async function(email, password) {
		ApiService.setCustomHeader(8, "", "");

        var recaptcha   = store.state.registration.recaptcha;
        var recaptchaV2 = store.state.registration.recaptchaV2;

        const url = 'main/customer/login?e=' + email +'&p=' + encodeURIComponent(password) + '&rbId=' + store.state.misc.appBranchId +'&recaptcha=' + recaptcha +'&recaptchaV2=' + recaptchaV2


        try {
            const response = await ApiService.get(url, {})
            //console.log("cust login :", response);

            if (response.data.status == '4000'){
                ApiService.saveFormData("uuid",response.data.result.uuid);
                ApiService.saveFormData("prefix",response.data.result.prefix);
                ApiService.saveFormData("otpIDD",response.data.result.otpIDD);
                ApiService.saveFormData("otpMobilePhone",response.data.result.otpMobilePhone);
                ApiService.saveFormData("tempToken",response.data.result.tempToken);
            }

            return response.data;
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Refresh the access token.
    **/
    refreshExpiredToken: async function(password) {
        // const refreshToken = TokenService.getRefreshToken()
        const userId = store.state.customer.customerId;
        //const authToken = "NDMxODM2ZGRiNzc2NGM4NDhiNjM5ZjI1OTg4YjA1MjM6YmZhOWI1OGI5MWRlNDMyMzhhNTRlMDM0MjA0NzE0ZWU=";


        const requestData = {
            method: 'post',
            url: "/oauth/oauth/refreshexpiredtoken",
            headers: {
                "Client-Id": process.env.VUE_APP_CLIENT_ID,
                "Refresh-Token": TokenService.getToken(),
                // "Authorization": "Basic NDMxODM2ZGRiNzc2NGM4NDhiNjM5ZjI1OTg4YjA1MjM6YmZhOWI1OGI5MWRlNDMyMzhhNTRlMDM0MjA0NzE0ZWU="
            },
            data: {
                clientId: process.env.VUE_APP_CLIENT_ID,
                appId: process.env.VUE_APP_APP_ID,
                userId: userId,
                userAgent: navigator.userAgent,
                userAuthorization: encodeURIComponent(password),
                deviceId: this.getSessionId(),
                ipAddress: ''
            },
            auth: {
                username: process.env.VUE_APP_CLIENT_ID,
                password: 'bfa9b58b91de43238a54e034204714ee'
            }
        }

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.customRequest(requestData)

            const result = ApiService.validateResponse(response, 'WN00020');

            TokenService.saveToken(result.access_token, f7.device.desktop);
            var now = new Date();
            var expiryTime = new Date(now.getTime() + (result.expires_in * 1000));
            TokenService.saveTokenExpiry(expiryTime, f7.device.desktop);
            ApiService.saveFormData("p2hCustomerId",result.p2hCustomerId);

            ApiService.setHeader()

            return response
        } catch (error) {
            console.log('error.errorCode:'+error.errorCode)
            throw new AuthenticationError(error.errorCode, error.message)
        }

    },

    /**
     * Refresh the access token.
    **/
    refreshToken: async function() {
        // const refreshToken = TokenService.getRefreshToken()
        const userId = store.state.customer.customerId;

        const requestData = {
            method: 'post',
            url: "/oauth/oauth/refreshtoken",
            headers: {
                "Client-Id": process.env.VUE_APP_CLIENT_ID,
                "Refresh-Token": TokenService.getToken(),
                //"Authorization": `Basic ` + authToken,
                // "Authorization": "Basic NDMxODM2ZGRiNzc2NGM4NDhiNjM5ZjI1OTg4YjA1MjM6YmZhOWI1OGI5MWRlNDMyMzhhNTRlMDM0MjA0NzE0ZWU="
            },
            data: {
                clientId: process.env.VUE_APP_CLIENT_ID,
                appId: process.env.VUE_APP_APP_ID,
                userId: userId,
                userAgent: navigator.userAgent,
                userAuthorization: '',
                deviceId: this.getSessionId(),
                ipAddress: ''
            },
            auth: {
                username: process.env.VUE_APP_CLIENT_ID,
                password: 'bfa9b58b91de43238a54e034204714ee'
            }
        }

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.customRequest(requestData)

            const result = ApiService.validateResponse(response, 'WN00020');

            TokenService.saveToken(result.access_token, f7.device.desktop);
            var now = new Date();
            var expiryTime = new Date(now.getTime() + (result.expires_in * 1000));
            TokenService.saveTokenExpiry(expiryTime, f7.device.desktop);
            ApiService.saveFormData("p2hCustomerId",result.p2hCustomerId);

            ApiService.setHeader()

            return response
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response.data.detail)
        }

    },

    /**
     * Logout the current user by removing the token from storage.
     *
     * Will also remove `Authorization Bearer <token>` header from future requests.
    **/
    logout() {
        // Remove the token and remove Authorization header from Api Service as well
        TokenService.removeToken()
        TokenService.removeRefreshToken()
        ApiService.removeHeader()
        ApiService.removeFormData("otpIDD")
        ApiService.removeFormData("otp")
        ApiService.removeFormData("tempToken")
        ApiService.removeFormData("otpMobilePhone")
        ApiService.removeFormData("prefix")
        ApiService.removeFormData("uuid")
        ApiService.removeFormData("_grecaptcha")
        ApiService.removeFormData("access_token_expiry")
        ApiService.removeFormData("is_using_biometry")
        ApiService.removeFormData("custName")
        ApiService.removeFormData("passReq");

        const isAxsrState = store.state.registration.isAxsr;
        if(isAxsrState){
            ApiService.removeFormData("axsQueryPartnerCode");
            ApiService.removeFormData("axsQuerySessionId");
            ApiService.removeFormData("axsQueryPartnerCustomerId");
            ApiService.removeFormData("axsQueryCustomerId");
            ApiService.removeFormData("axsQuerySignature");
        }

        ApiService.unmount401Interceptor()
        this.removeSessionId()
        store.commit('customer/resetCustomerState');
    },

    validatePartnerCustomerDetails: async function(partnerCode, sessionId, partnerCustomerId, customerId, signature, path) {
        const param = {
            partnerCode : partnerCode,
            sessionId : sessionId,
            partnerCustomerId : partnerCustomerId,
            customerId : customerId,
            signature : signature,
            url: path
        }

        const url = 'main/customer/partner/validate'

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.post(url, param)

            //console.log("validatePartnerCustomerDetails service", response);

            //return ApiService.validateResponse(response, '13000');
            return response.data;

            /*return {
                "status": "13000",
                "message": null,
                "result": {
                    "p2hCustomerId": 0
                }
            }*/
        } catch (e) {
            console.log(e)
            if (e instanceof GenericError) {
                throw e
            }
        }
    },

    validateLoginOtp: async function(email, password) {

        try {
            // let sgTime = new Date().toLocaleString("en-US", {timeZone: 'Asia/Singapore'});
            // var today = new Date(sgTime);
            // var dd = String(today.getDate()).padStart(2, '0');
            // var MM = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            // var yy = today.getFullYear().toString().substr(-2);
            // var todayNew = MM + dd + yy;
            const randVal = await ApiService.getRandomValue();
            var secretKeyOTP  = process.env.VUE_APP_OPSTK+randVal;
            var secretKeyPass = process.env.VUE_APP_PSSTK+randVal;

            var encryptedOTP = CryptoAES.encrypt(secretKeyOTP, ApiService.getFormData("otp"));
            var encryptedPassword = CryptoAES.encrypt(secretKeyPass, password);

            ApiService.setCustomHeader(5, ApiService.getFormData("tempToken"), encodeURIComponent(encryptedOTP));

            const url = 'main/verify/login?e=' + email +'&p=' + encodeURIComponent(encryptedPassword) + '&rbId=' + store.state.misc.appBranchId


            const params ={
            }

            const response = await ApiService.get(url,params)
            //console.log("validateLoginOtp : "+response);
            const result = ApiService.validateResponse(response, '0100');

            var now = new Date();
            var expiryTime = new Date(now.getTime() + (result.expires_in * 1000));
            TokenService.saveTokenExpiry(expiryTime, f7.device.desktop);
            TokenService.saveToken(result.access_token, f7.device.desktop);

            ApiService.setHeader()

            ApiService.mount401Interceptor();

            if(response.data.status == "0100") {
                this.generateSessionId();
            }

            return response;

        } catch (e) {
            console.log("fail"+e)

            if (e.response.data.status !== undefined){
                throw new AuthenticationError(e.response.data.status, e.response.data.message)
            }else{
                throw new AuthenticationError(e.response.status, e.response.statusText)
            }

        }
    },

    validatebydob: async function(dob, userId) {

        const requestData = {
            method: 'post',
            url: "main/customer/partner/validatebydob", // TODO: change path
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*"
            },
            data: {
                clientId: process.env.VUE_APP_CLIENT_ID,
                appId: process.env.VUE_APP_APP_ID,
                userAgent: navigator.userAgent,
                dob: dob,
                mobileNo: ApiService.getFormData("shMobileNo"),
                userId: userId
            },
            auth: {
                username: process.env.VUE_APP_CLIENT_ID,
                password: process.env.VUE_APP_CLIENT_SECRET
            }
        }

        try {

            await ApiService.generateAuthClient();
            const response = await ApiService.customRequest(requestData)

           // const result = ApiService.validateResponse(response, 'SH2000');




           // ApiService.setHeader()

            //ApiService.mount401Interceptor();


            return response
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response.data.detail)
        }


    },

    forgotPassword: async function(email) {

        try {
            let sgTime = new Date().toLocaleString("en-US", {timeZone: 'Asia/Singapore'});
            var today = new Date(sgTime);
            var dd = String(today.getDate()).padStart(2, '0');
            var MM = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            // var y = today.getFullYear().toString().substr(-1);
            var HH = String(today.getHours()).padStart(2, '0');
            // var m = String(today.getMinutes()).padStart(2, '0').charAt(0);
            var s = String(today.getSeconds()).padStart(2, '0');
            // var currDate = MM + dd + y + HH + m;
            var currDateTime = MM+"/"+dd+"/"+today.getFullYear().toString()+" "+HH+":"+String(today.getMinutes()).padStart(2, '0')+":"+s;
            //console.log("currDate: "+currDate);
            const randVal = await ApiService.getRandomValue();
            var secretKeyEmail  = process.env.VUE_APP_FPSTK+randVal;
            //console.log("secretKeyEmail: "+secretKeyEmail);

            var encryptedEmail = CryptoAES.encrypt(secretKeyEmail, email);

            ApiService.setCustomHeader(8, "forgotPassword", currDateTime);


           const url = 'main/request/forgotPassword?e=' + email + '&rbId=' + store.state.misc.appBranchId + '&token=' + encodeURIComponent(encryptedEmail);


           const params = {

            }
            await ApiService.generateAuthClient(randVal);
           const response = await ApiService.get(url,params)

           //console.log("forgotPassword: ", response);
           return response.data;

        } catch (e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }

        }

    },

    verifyForgotPassword: async function() {
        const id = store.state.customer.resetPasswordId;
        const fpvc = store.state.customer.resetPasswordFpvc;
        //console.log("id: "+id+" # fpvc: "+fpvc);

        try {
            ApiService.setCustomHeader(8, "", "");

            const encodedFpvc = encodeURIComponent(fpvc);

            const url = 'main/verify/forgotPassword?id=' + id + '&rbId=' + store.state.misc.appBranchId + '&fpvc=' + encodedFpvc;


            const params = {

            }

            await ApiService.generateAuthClient();
            const response = await ApiService.get(url,params)
            //console.log("verifyForgotPassword: ", response.data)
            ApiService.saveFormData("tempToken",response.data.result.tempToken);
            return response.data;

        } catch (e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }

        }

    },

    updateForgotPassword: async function() {
        const newPassword = store.state.customer.newPassword;
        const fpvc = store.state.customer.resetPasswordFpvc;
        const encodedFpvc = encodeURIComponent(fpvc);
        //console.log("newPassword: "+newPassword+" # fpvc: "+fpvc);

        try {
            // let sgTime = new Date().toLocaleString("en-US", {timeZone: 'Asia/Singapore'});
            // var today = new Date(sgTime);
            // var dd = String(today.getDate()).padStart(2, '0');
            // var MM = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            // var yy = today.getFullYear().toString().substr(-2);
            // var y = today.getFullYear().toString().substr(-1);
            // var HH = String(today.getHours()).padStart(2, '0');
            // var m = String(today.getMinutes()).padStart(2, '0').charAt(0);
            // var currDate = MM + dd + y + HH + m;
            // var todayNew = MM + dd + yy;
            const randVal = await ApiService.getRandomValue();
            var secretKeyNewPassword  = process.env.VUE_APP_FPSTK+randVal;
            var secretKeyOTP  = process.env.VUE_APP_OPSTK+randVal;

            var encryptedNewPassword = CryptoAES.encrypt(secretKeyNewPassword, newPassword);
            var encryptedOTP = CryptoAES.encrypt(secretKeyOTP, ApiService.getFormData("otp"));

            ApiService.setCustomHeader(5, ApiService.getFormData("tempToken"), encodeURIComponent(encryptedOTP));


           const url = 'main/update/forgotPassword?p=' + encodeURIComponent(encryptedNewPassword) + '&rbId=' + store.state.misc.appBranchId + '&fpvc=' + encodedFpvc;


           const params = {

            }
            await ApiService.generateAuthClient(randVal);
           const response = await ApiService.get(url,params)
           //console.log("updateForgotPassword: ", response.data)

           return response.data;

        } catch (e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }

        }

    },

    getCustomerDetails: async function() {
        const url = 'main/customer'

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            // console.log(response)
            if (response && response != undefined && response.data.status == '0300') {
                ApiService.saveFormData("custName", response.data.result.customerName);
                ApiService.saveFormData("custAlias", response.data.result.customerAlias);
                ApiService.saveFormData("custEmail", response.data.result.email);
            }
            return ApiService.validateResponse(response, '0300')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getBeneficiaryQuickSend: async function(beneLimit) {
        ApiService.setCustomHeader(2, TokenService.getToken(), "");

        const url = 'main/beneficiary/quicksend'
        const params = {
            limit : beneLimit,
            countries : process.env.VUE_APP_SUPPORTED_COUNTRIES
        }

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            // console.log(response)
            return ApiService.validateResponse(response, '0404')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    updateCustomerEmail: async function(pin, token, oldEmail, newEmail) {
        // let sgTime = new Date().toLocaleString("en-US", {timeZone: 'Asia/Singapore'});
        // var today = new Date(sgTime);
        // var dd = String(today.getDate()).padStart(2, '0');
        // var MM = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        // var yy = today.getFullYear().toString().substr(-2);
        // var todayNew = MM + dd + yy;
        const randVal = await ApiService.getRandomValue();
        console.log("updateCustomerEmail : "+ApiService.getFormData("is_using_biometry")+" ## "+ApiService.getFormData("passReq")+" ## "+store.state.customer.tempUpdateAccountToken)
        var param = {
            pin: '',
            dob: '',
            mobileCountryId: 0,
            mobile: '',
            oldEmail: oldEmail,
            newEmail: newEmail,
        }

        if(pin != '') {
            var secretKeyPass = process.env.VUE_APP_PSSTK+randVal;
            var encryptedPassword = CryptoAES.encrypt(secretKeyPass, pin);
            param.pin = encodeURIComponent(encryptedPassword);
        } else if(token != '') {
            param.addOns = token
        }

        if(ApiService.getFormData("is_using_biometry")){
            console.log("is_using_biometry true")
            param.userAuthorization = encodeURIComponent(store.state.customer.tempUpdateAccountToken)
        }else{
            console.log("is_using_biometry false")
        }

        console.log("params sent : "+param.pin+" @@ "+param.oldEmail+" @@ "+param.newEmail+" @@ "+param.addOns+" @@ "+param.userAuthorization)

        const url = 'main/customer/email'

        try {
            await ApiService.generateAuthClient(randVal);
            const response = await ApiService.post(url, param)
            return ApiService.validateResponse(response, '3130');
        } catch (e) {
            console.log(e)
            if (e instanceof GenericError) {
                throw e
            }
        }
    },

    updateCustomerMobileNumber: async function() {
        // let sgTime = new Date().toLocaleString("en-US", {timeZone: 'Asia/Singapore'});
        // var today = new Date(sgTime);
        // var dd = String(today.getDate()).padStart(2, '0');
        // var MM = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        // var yy = today.getFullYear().toString().substr(-2);
        // var todayNew = MM + dd + yy;
        const randVal = await ApiService.getRandomValue();
        var secretKeyOTP  = process.env.VUE_APP_OPSTK+randVal;
        var encryptedOTP = CryptoAES.encrypt(secretKeyOTP, ApiService.getFormData("otp"));

        ApiService.setCustomHeader(5, TokenService.getToken(), encodeURIComponent(encryptedOTP));

        var param = {
            pin: '',
            dob: '',
            mobileCountryId: store.state.misc.mobileCountryId,
            mobile: store.state.misc.mobileNo,
            newMobileCountryId: store.state.misc.newMobileCountryId,
            newMobile: store.state.misc.newMobileNo
        }

        if(store.state.misc.password != '') {
            var secretKeyPass = process.env.VUE_APP_PSSTK+randVal;
            var encryptedPassword = CryptoAES.encrypt(secretKeyPass, store.state.misc.password);
            param.pin = encodeURIComponent(encryptedPassword);
        } else if(store.state.misc.appleToken != '') {
            param.addOns = store.state.misc.appleToken;
        }

        if(ApiService.getFormData("is_using_biometry")){
            console.log("is_using_biometry true")
            param.userAuthorization = encodeURIComponent(store.state.customer.tempUpdateAccountToken)
        }else{
            console.log("is_using_biometry false")
        }

        //console.log("updateCustomerMobileNumber : "+param.pin+" @@"+ApiService.getFormData("is_using_biometry")+" @@ "+param.userAuthorization)

        const url = 'main/customer/mobilenumber'
        try {
            await ApiService.generateAuthClient(randVal);
            const response = await ApiService.post(url, param)

            return response.data;
        } catch (e) {
            console.log(e)
            if (e instanceof GenericError) {
                throw e
            }
        }
    },

    validateCustomerEmail: async function(oldEmail, newEmail) {
        const param = {
            pin: '',
            dob: '',
            mobileCountryId: 0,
            mobile: '',
            oldEmail: oldEmail,
            newEmail: newEmail
        }

        const url = 'main/customer/validate/email'

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.post(url, param)
            return ApiService.validateResponse(response, '3130');
        } catch (e) {
            console.log(e)
            if (e instanceof GenericError) {
                throw e
            }
        }
    },

    validateCustomerMobileNumber: async function() {
        // let sgTime = new Date().toLocaleString("en-US", {timeZone: 'Asia/Singapore'});
        // var today = new Date(sgTime);
        // var dd = String(today.getDate()).padStart(2, '0');
        // var MM = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        // var yy = today.getFullYear().toString().substr(-2);
        // var todayNew = MM + dd + yy;
        const randVal = await ApiService.getRandomValue();
        ApiService.setCustomHeader(2, TokenService.getToken(), "");

        var param = {
            pin: '',
            dob: '',
            mobileCountryId: store.state.misc.mobileCountryId,
            mobile: store.state.misc.mobileNo,
            newMobileCountryId: store.state.misc.newMobileCountryId,
            newMobile: store.state.misc.newMobileNo
        }

        if(store.state.misc.password != '') {
            var secretKeyPass = process.env.VUE_APP_PSSTK+randVal;
            var encryptedPassword = CryptoAES.encrypt(secretKeyPass, store.state.misc.password);
            param.pin = encodeURIComponent(encryptedPassword);
        } else if(store.state.misc.appleToken != '') {
            param.addOns = store.state.misc.appleToken;
        }


        if(ApiService.getFormData("is_using_biometry")){
            console.log("is_using_biometry true")
            param.userAuthorization = encodeURIComponent(store.state.customer.tempUpdateAccountToken)
        }

        const url = 'main/customer/validate/mobilenumber'
        try {
            await ApiService.generateAuthClient(randVal);
            const response = await ApiService.post(url, param)

            return response.data;
        } catch (e) {
            console.log(e)
            if (e instanceof GenericError) {
                throw e
            }
        }
    },

    updateCustomerOccupation: async function(occupation) {
        const url = 'main/customer/occupation/'+occupation
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            return ApiService.validateResponse(response, 'WN00124');
        } catch (e) {
            console.log(e)
            if (e instanceof GenericError) {
                throw e
            }
        }
    },

    updateCustomerDetail: async function(customer) {
        const param = {
            firstName       : encodeURIComponent(customer.firstName),
            nationalityId   : customer.nationalityId,
            gender          : customer.gender,
            dob             : customer.dob,
            identificationNo: encodeURIComponent(customer.identificationNo),
            occupation      : encodeURIComponent(customer.occupation),
            industry        : customer.employment,
            email           : customer.email,
            address         : "",
            employer        : "",
            myinfoToken     : ""
        }

        const url = 'main/customer/update'
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.post(url, param)
            return ApiService.validateResponse(response, 'WN00111');
        } catch (e) {
            console.log(e)
            if (e instanceof GenericError) {
                throw e
            }
        }
    },

    validateBiometric: async function(token) {
        const requestData = {
            method: 'post',
            url: '/oauth/oauth/biometric',
            headers: {
                "Client-Id": process.env.VUE_APP_CLIENT_ID,
                "Refresh-Token": TokenService.getToken(),
                'Content-Type': 'application/json',
                // 'client-id': process.env.VUE_APP_CLIENT_ID,
                'Authorization': "Basic NDMxODM2ZGRiNzc2NGM4NDhiNjM5ZjI1OTg4YjA1MjM6YmZhOWI1OGI5MWRlNDMyMzhhNTRlMDM0MjA0NzE0ZWU="
            },
            data: {
                clientId : process.env.VUE_APP_CLIENT_ID,
                appId : 1,
                userAgent : 'ua',
                userAuthorization : encodeURIComponent(token),
                deviceId: this.getSessionId()?this.getSessionId():('reg:'+Date.now()),
            }
        }

        try {
            store.commit('customer/setTempUpdateAccountToken', token);
            await ApiService.generateAuthClient();
            const response = await ApiService.customRequest(requestData)

            var now = new Date();
            var expiryTime = new Date(now.getTime() + (response.data.result.expires_in * 1000));
            TokenService.saveTokenExpiry(expiryTime, f7.device.desktop);
            TokenService.saveToken(response.data.result.access_token, f7.device.desktop);
            this.generateSessionId();
            ApiService.setHeader()

            store.commit('auth/loggedIn', response.data.result.access_token);

            return response.data;
        } catch (e) {
            return false;
        }
    },

    googleLogin: async function(code) {
		ApiService.setCustomHeader(8, "", "");

        const url = 'main/google/login?code=' + code + '&rbId=' + store.state.misc.appBranchId
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            if (response.data.status == '0100') {
                var now = new Date();
                var expiryTime = new Date(now.getTime() + (response.data.result.expires_in * 1000));
                TokenService.saveTokenExpiry(expiryTime, f7.device.desktop);
                TokenService.saveToken(response.data.result.access_token, f7.device.desktop);
                ApiService.setHeader()
                ApiService.mount401Interceptor();
                this.generateSessionId();
                store.commit('auth/loggedIn', response.data.result.access_token);
            } else if(response.data.status == "WN00118") {
                TokenService.saveToken(response.data.result.token, f7.device.desktop);
            }

            return response.data;
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response.data.detail)
        }
    },

    appleLogin: async function(code, isRefreshToken) {
		ApiService.setCustomHeader(8, "", "");

        const url = 'main/apple/login?code=' + code + '&rbId=' + store.state.misc.appBranchId
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            if (response.data.status == '0100' && isRefreshToken) {
                if(response.data.result.email == store.state.customer.email && response.data.result.p2hCustomerId == store.state.customer.customerId) {
                    var nowT = new Date();
                    var expiryTimeT = new Date(nowT.getTime() + (response.data.result.expires_in * 1000));
                    TokenService.saveTokenExpiry(expiryTimeT, f7.device.desktop);
                    TokenService.saveToken(response.data.result.access_token, f7.device.desktop);
                    ApiService.saveFormData("passReq", response.data.result.passReq);
                    ApiService.setHeader();
                } else {
                    response.data.status = 'INVALID_EMAIL_OR_CRN';
                }
            } else if(response.data.status == '0100') {
                var now = new Date();
                var expiryTime = new Date(now.getTime() + (response.data.result.expires_in * 1000));
                TokenService.saveTokenExpiry(expiryTime, f7.device.desktop);
                TokenService.saveToken(response.data.result.access_token, f7.device.desktop);
                ApiService.saveFormData("passReq", response.data.result.passReq);
                ApiService.setHeader()
                ApiService.mount401Interceptor();
                this.generateSessionId();
                store.commit('auth/loggedIn', response.data.result.access_token);
            } else if(response.data.status == "WN00118" && !isRefreshToken) {
                TokenService.saveToken(response.data.result.token, f7.device.desktop);
            }

            return response.data;
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response.data.detail)
        }
    },

    googleRegister: async function(code) {
		ApiService.setCustomHeader(8, "", "");

        const url = 'main/google/register?code=' + code + '&rbId=' + store.state.misc.appBranchId
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            if(response.data.status == "WN00118") {
                TokenService.saveToken(response.data.result.token, f7.device.desktop);
            }

            return response.data;
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response.data.detail)
        }
    },

    appleRegister: async function(code) {
		ApiService.setCustomHeader(8, "", "");

        const url = 'main/apple/register?code=' + code + '&rbId=' + store.state.misc.appBranchId
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            if(response.data.status == "WN00118") {
                TokenService.saveToken(response.data.result.token, f7.device.desktop);
            }

            return response.data;
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response.data.detail)
        }
    },

    getInboxMessage: async function(startIndex, searchLimit,isRead) {

        const params = {
            startIndex  : startIndex,
            searchLimit : searchLimit,
            isRead      : isRead,

        }

        const url = 'main/customer/message'


        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            // console.log(response)
            return ApiService.validateResponse(response, '3700')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },
    getUnreadNotification: async function(  ) {


        const url = 'main/customer/unread/count'


        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            // console.log(response)
            return ApiService.validateResponse(response, '3160')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    updateInboxMessageAsRead: async function(ids) {
        const url = 'main/customer/message/markasread'

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.put(url, {"messageIds" : ids})
            // console.log(response)
            return ApiService.validateResponse(response, '3702')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getSingpassURL: async function(isUsingInAppBrowser, loginType) {
        ApiService.setCustomHeader(2, TokenService.getToken(), "");
        var url = 'main/login/myverify/url?rbId='+store.state.misc.appBranchId+'&type='+loginType
        if(isUsingInAppBrowser) {
            url += '&version=1';
        }
        url += ApiService.getMyinfoSignalQuery(); // DR-1931: forward osName/appVersion for v5 routing

        let params = {}
        const isAxsrState = store.state.registration.isAxsr;
        if(isAxsrState){
            params.client_id = process.env.VUE_APP_AXSR_CLIENT_ID
        }

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            // console.log(response)
            return ApiService.validateResponse(response, '4856')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    singpassLogin: async function(isUsingInAppBrowser, state, code) {
		ApiService.setCustomHeader(8, "", "");

        var url = 'main/myinfo/landing?state=' + state + '&code=' + code + '&rbId=' + store.state.misc.appBranchId
        if(isUsingInAppBrowser) {
            url += '&version=1';
        }

        let params = {}
        const isAxsrState = store.state.registration.isAxsr;
        if(isAxsrState){
            params.client_id = process.env.VUE_APP_AXSR_CLIENT_ID
        }
        console.log("singpassLogin service, AXS ? "+isAxsrState)

        try {
            const response = await ApiService.get(url, {params})
            // console.log("singpass login :", response);

            if (response.data.status == '0100'){
                var now = new Date();
                var expiryTime = new Date(now.getTime() + (response.data.result.expires_in * 1000));
                TokenService.saveTokenExpiry(expiryTime, f7.device.desktop);
                TokenService.saveToken(response.data.result.access_token, f7.device.desktop);
                ApiService.setHeader()
                ApiService.mount401Interceptor();
                this.generateSessionId();
                store.commit('auth/loggedIn', response.data.result.access_token);
            } else if(response.data.status == "WN00118") {
                TokenService.saveToken(response.data.result.token, f7.device.desktop);
            }

            return response.data;
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response.data.detail)
        }
    },

    getMyInfoUrl: async function(isUsingInAppBrowser) {
        var url = 'main/myinfo/url?rbId='+store.state.misc.appBranchId
        if(isUsingInAppBrowser) {
            url += '&version=1';
        }
        url += ApiService.getMyinfoSignalQuery(); // DR-1931: forward osName/appVersion for v5 routing

        let params = {}
        const isAxsrState = store.state.registration.isAxsr;
        if(isAxsrState){
            params.client_id = process.env.VUE_APP_AXSR_CLIENT_ID
        }

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            return ApiService.validateResponse(response, '4856')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    updateCustomerMyInfo: async function(isUsingInAppBrowser) {
        const dobVal = store.state.myinfo.dob;
        const dobArr = dobVal.split("-");
        const year = dobArr[2];
        const month = dobArr[1];
        const day = dobArr[0];
        const newDate = [year, month, day].join('-');

        // console.log("MYINFO DATA TO SUBMIT : ", store.state.myinfo)

        let param = {
            firstName       : store.state.myinfo.fullName == undefined ? "" : store.state.myinfo.fullName,
            identificationNo: store.state.myinfo.identificationNo == undefined ? "" : store.state.myinfo.identificationNo,
            gender          : (store.state.myinfo.gender == "Male" ? "M" : "F"),
            nationalityId   : store.state.myinfo.nationalityId == undefined ? 0 : store.state.myinfo.nationalityId,
            dob             : newDate,
            email           : store.state.myinfo.email == undefined ? "" : store.state.myinfo.email,
            occupation      : store.state.myinfo.occupation == undefined ? "" : store.state.myinfo.occupation,
            industry        : store.state.myinfo.employmentSector == undefined ? "" : store.state.myinfo.employmentSector,
            address         : store.state.myinfo.address == undefined ? "" : store.state.myinfo.address,
            employer        : store.state.myinfo.employerName == undefined ? "" : store.state.myinfo.employerName,
            myinfoToken     : store.state.myinfo.myInfoState,
        }

        const isAxsrState = store.state.registration.isAxsr;
        if(isAxsrState){
            param.client_id = process.env.VUE_APP_AXSR_CLIENT_ID
        }

        var url = 'main/customer/update/myinfo?rbId='+store.state.misc.appBranchId
        if(isUsingInAppBrowser) {
            url += '&version=1';
        }

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.post(url, param)
            //return ApiService.validateResponse(response, '4851');
            return response.data
        } catch (e) {
            console.log(e)
            if (e instanceof GenericError) {
                throw e
            }
        }
    },

    generateSessionId: function() {
        ApiService.saveFormData("session-id", 'sess:'+Date.now());
    },
    getSessionId: function() {
        return ApiService.getFormData("session-id");
    },
    removeSessionId: function() {
        ApiService.removeFormData("session-id")
    },

    resendEmailVerificationLink: async function(newEmail) {
        ApiService.setCustomHeader(2, TokenService.getToken(), "");

        let newEmailParam = !newEmail ? '' : newEmail

        const url = 'main/customer/resendemail?newEmail=' + newEmailParam
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            // console.log(response)
            return response.data
        } catch(e) {
            // console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    saveAlias: async function(alias) {

        const customerAlias   = alias == undefined ? "" : alias; //store.state.customer.customerAlias;

        const url = 'main/customer/alias?alias='+encodeURIComponent(customerAlias)


        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            //console.log("saveAlias : ", response)
            return response.data
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    updateLastFxCalcCurrencyId: async function(currId) {
        const url = 'main/update/lastFxCalc/'+currId

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            //console.log("updateLastFxCalcCurrencyId : ", response)
            return response.data
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    isEkycNeedPOA: function(customer){
        var result = true;
        if(customer.customerDocumentList != null && customer.customerDocumentList.length > 0) {
            for(let doc of customer.customerDocumentList) {
                if((doc.identificationTypeId == process.env.VUE_APP_DOCUMENT_ID_NATIONAL_ID || doc.identificationTypeId == 54 || 
                    doc.identificationTypeId == process.env.VUE_APP_DOCUMENT_ID_EKYC_NATIONAL_ID || doc.identificationTypeId == 154 || 
                    doc.identificationTypeId == 216 || doc.identificationTypeId == 217) && doc.issuingCountryId == 189) {
                    result = false;
                }
            }
        }

        return (result && customer.regRetailAgentId == process.env.VUE_APP_RETAIL_AGENT_ID);
    },
}

export default CustomerService

export { CustomerService, AuthenticationError }

